if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // this.cartNotification = document.querySelector('cart-notification');
        this.cartDrawerItems = document.querySelector('cart-items');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;
        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          ...JSON.parse(serializeForm(this.form)),
          sections: this.cartDrawerItems
            .getSectionsToRender()
            .map(section => section.id),
          sections_url: window.location.pathname,
        });


        fetch(`${routes.cart_add_url}`, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }


            const quickViewPopup = document.querySelector('.product__quick-view-popup');
            if (quickViewPopup) {
              if (quickViewPopup.classList.contains('product__quick-view-popup_active')) {
                quickViewPopup.classList.remove('product__quick-view-popup_active');
                document.body.classList.remove('overflow-hidden');
              }
            }

            this.cartDrawerItems.renderContents(response);

            // We need to fetch the cart to get the total price ... the add route doesn't return this //
            fetch(`${routes.cart_url}`, config)
              .then(response => response.json())
              .then(response => {
                window.cartDrawer.updateCartPrices(response);
                window.cartDrawer.updateCartTitle('Added To Your Cart');
                window.cartDrawer.updateCartItemCount(response.item_count);
                window.cartDrawer.updateCartPromo(response);
              });
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
